var _g, _defs;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgEmptyStage = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 151,
    viewBox: "0 0 200 151",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Empty state / illustrations / general",
    clipPath: "url(#clip0_13720_445801)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M100 131.145C133.935 131.145 161.446 103.577 161.446 69.4514C161.446 35.3256 133.814 7.75781 100 7.75781C66.0659 7.75781 38.5547 35.3256 38.5547 69.4514C38.5547 103.577 66.0659 131.145 100 131.145Z",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M156.159 28.6088C158.887 28.6088 161.098 26.3883 161.098 23.6491C161.098 20.91 158.887 18.6895 156.159 18.6895C153.43 18.6895 151.219 20.91 151.219 23.6491C151.219 26.3883 153.43 28.6088 156.159 28.6088Z",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M163.389 9.25466C165.252 9.25466 166.763 7.73821 166.763 5.86757C166.763 3.99692 165.252 2.48047 163.389 2.48047C161.526 2.48047 160.016 3.99692 160.016 5.86757C160.016 7.73821 161.526 9.25466 163.389 9.25466Z",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M41.2172 28.4881C43.0804 28.4881 44.5907 26.9716 44.5907 25.101C44.5907 23.2303 43.0804 21.7139 41.2172 21.7139C39.3541 21.7139 37.8438 23.2303 37.8438 25.101C37.8438 26.9716 39.3541 28.4881 41.2172 28.4881Z",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M20.6166 93.8111C24.0767 93.8111 26.8817 90.9948 26.8817 87.5208C26.8817 84.0467 24.0767 81.2305 20.6166 81.2305C17.1565 81.2305 14.3516 84.0467 14.3516 87.5208C14.3516 90.9948 17.1565 93.8111 20.6166 93.8111Z",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M99.0108 96.2751L96.8759 96.2437C96.4489 96.2374 96.0273 95.8028 96.0591 95.2741C96.0909 94.7454 96.4232 94.2967 96.8502 94.303L98.9851 94.3344C99.4121 94.3407 99.8337 94.7753 99.8019 95.304C99.7437 95.9331 99.4378 96.2814 99.0108 96.2751Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 738"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector_7",
    filter: "url(#filter0_d_13720_445801)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.3415 39.7888L115.23 93.158C116.095 95.007 115.331 97.1567 113.49 98.025L61.29 122.776C59.4492 123.644 57.3084 122.876 56.4432 121.027L23.9922 51.9535C23.1269 50.1044 23.8908 47.9548 25.7317 47.0865L63.5105 29.2259L89.3415 39.7888Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M63.5234 29.2119L70.4553 44.0215C71.4612 46.0587 74.0463 46.9589 76.0702 45.9518L89.3519 39.8057",
    fill: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 737"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector_9",
    filter: "url(#filter1_d_13720_445801)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.198 45.1693L136.03 104.473C136.03 106.514 134.427 108.128 132.391 108.122L74.5973 108.08C72.5611 108.075 70.9468 106.463 70.9467 104.422L70.8256 28.1203C70.8254 26.0793 72.429 24.4656 74.4651 24.4712L116.27 24.5485L135.198 45.1693Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M116.305 24.4971L116.292 40.8304C116.338 43.0996 118.298 45.0181 120.559 44.9748L135.203 45.1083",
    fill: "#E6E6E6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector_11",
    filter: "url(#filter2_d_13720_445801)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171.571 71.5187L147.485 125.676C146.684 127.503 144.436 128.3 142.636 127.39L90.219 103.1C88.3929 102.291 87.5901 100.036 88.3916 98.2086L120.177 29.0263C120.978 27.1993 123.226 26.4023 125.025 27.3119L163.088 44.9812L171.571 71.5187Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M162.986 44.8816L156.189 59.7272C155.207 61.8298 156.257 64.3658 158.356 65.3547L171.552 71.4483",
    fill: "#E6E6E6"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_13720_445801",
    x: -0.367188,
    y: 13.2256,
    width: 139.953,
    height: 141.906,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0666667 0 0 0 0 0.247059 0 0 0 0 0.631373 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13720_445801"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13720_445801",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_13720_445801",
    x: 46.8281,
    y: 8.4707,
    width: 113.203,
    height: 131.651,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0666667 0 0 0 0 0.247059 0 0 0 0 0.631373 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13720_445801"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13720_445801",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_13720_445801",
    x: 64.0781,
    y: 10.9346,
    width: 131.492,
    height: 148.833,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0666667 0 0 0 0 0.247059 0 0 0 0 0.631373 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13720_445801"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13720_445801",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13720_445801"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 150,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEmptyStage, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/empty-stage.2c2b0752.svg";
export { ForwardRef as ReactComponent };